<template>
    <div v-if="addDeposit">
        <input type="hidden" :id="id"
               :name="name" class="deposit"/>
<!--        // to do by khaled and mina get add deposit-->
    </div>
</template>

<script>
export default {
    name: "DepositField",
    props: {
        service: {
            type: Object,
            required: true,
        },
        addDeposit: true
    },
    computed:{
        name() {
            if (parseInt(this.service.clone)) {
                return `service_deposit_${this.service.service_id}_${this.service.clone}`;
            }

            return `service_deposit_${this.service.service_id}`;
        }   ,
        id() {
            if (parseInt(this.service.clone)) {
                return `service_deposit_${this.service.service_id}_${this.service.clone}`;
            }

            return `service_deposit_${this.service.service_id}`;
        }
    }
}
</script>

<style scoped>

</style>